import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { HeaderCommandBar } from "../command-bar/HeaderCommandBar";
import "./PageHeader.scss";

interface PageHeaderProps {
  title?: string;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  /**
   * Compact mode: a slim strip with just the command bar and no centered title.
   * For vertically-tight pages (e.g. the log viewer) that still need the menu
   * but can't spare the full 48px header.
   */
  compact?: boolean;
}

export function PageHeader({
  title,
  leftContent,
  rightContent,
  compact = false,
}: PageHeaderProps) {
  const height = compact ? 32 : 48;
  return (
    <AppBar
      position="static"
      className={`page-header _PageHeader.tsx${
        compact ? " page-header--compact" : ""
      }`}
      elevation={0}
      sx={{ height }}
    >
      <Toolbar className="page-header-toolbar" disableGutters>
        <Box className="page-header-left-group">
          <HeaderCommandBar />
          {leftContent && (
            <Box className="page-header-left" sx={{ ml: 2 }}>
              {leftContent}
            </Box>
          )}
        </Box>

        {!compact && (
          <Box className="centered-title">
            {title && (
              <Typography variant="h6" component="div">
                {title}
              </Typography>
            )}
          </Box>
        )}

        {!compact && (
          <Box className="page-header-right-group">
            {rightContent && (
              <Box className="page-header-right" sx={{ ml: 2 }}>
                {rightContent}
              </Box>
            )}
            {!rightContent && <Box className="page-header-right-spacer" />}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
